<template>
	<q-page padding>
		<div class="row q-mb-sm">
			<div class="col-xs-12 col-sm-12">
				<div class="q-display-1 text-secondary">
					<q-icon name="far fa-list" class="q-mb-sm" /> {{ $t(title_live_class) }}
				</div>
			</div>
		</div>

		<q-tabs v-model="tab">
			<q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
			<q-tab slot="title" name="guests" :label="$t('guests')" v-show="showTab && guestType" />
			<q-tab
				slot="title"
				name="subscribers"
				:label="$t('subscribers')"
				v-show="showTab && !guestType"
			/>
			<q-tab slot="title" name="tests" :label="$t('tests')" v-show="showTab" />
			<q-tab
				slot="title"
				name="support_material"
				:label="$t('support_materials')"
				v-show="showTab"
			/>
			<q-tab
				slot="title"
				name="reaction_tests"
				:label="$t('reaction_tests')"
				v-show="showTab"
			/>
			<q-tab slot="title" name="live-class" :label="$t('live_class')" v-show="showTab" />
			<q-tab
				slot="title"
				v-if="useReviews"
				name="comments"
				:label="$t('comments')"
				v-show="showTab"
			/>

			<q-tab-pane name="basic-data">
				<basic-data
					:manageLiveClasses="permissions.live_classes_manage"
					@updateClassData="updateClassData"
				/>
			</q-tab-pane>

			<q-tab-pane name="guests">
				<guests
					:allowed_guest_areas="allowed_guest_areas"
					:allowed_guest_profiles="allowed_guest_profiles"
					:guest_limit="live_class_guest_limit"
					:manageLiveClasses="permissions.live_classes_manage"
				/>
			</q-tab-pane>

			<q-tab-pane name="subscribers">
				<subscribers :manageLiveClasses="permissions.live_classes_manage" />
			</q-tab-pane>

			<q-tab-pane name="tests">
				<tests :manageLiveClasses="permissions.live_classes_manage" />
			</q-tab-pane>

			<q-tab-pane name="support_material">
				<support-material :manageLiveClasses="permissions.live_classes_manage" />
			</q-tab-pane>

			<q-tab-pane name="reaction_tests">
				<reaction-tests :manageLiveClasses="permissions.live_classes_manage" />
			</q-tab-pane>

			<q-tab-pane name="live-class">
				<live-class
					:platform_type="platform_type"
					:embed="embed"
					:title="live_class_title"
					:description="live_class_description"
					:room="live_class_room"
					:date_class="date_class"
					:timezone="timezone"
					:status="status"
				/>
			</q-tab-pane>

			<q-tab-pane name="comments">
				<comments origin="live_class" />
			</q-tab-pane>
		</q-tabs>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicDataTab from 'components/admin/live_classe/BasicDataTab'
import GuestsTab from 'components/admin/live_classe/GuestsTab'
import SubscribersTab from 'components/admin/live_classe/SubscribersTab'
import LiveClassTab from 'components/admin/live_classe/LiveClassTab'
import TestsTab from 'components/admin/live_classe/TestsTab'
import ReactionTestsTab from 'components/admin/live_classe/ReactionTestsTab'
import Comments from 'components/admin/Comments'
import SupportMaterialTab from 'components/admin/live_classe/SupportMaterialTab'

export default {
	i18nOptions: {
		namespaces: ['custom', 'common', 'admin', 'live_classes', 'courses', 'presential'],
	},

	components: {
		'basic-data': BasicDataTab,
		guests: GuestsTab,
		subscribers: SubscribersTab,
		'live-class': LiveClassTab,
		'support-material': SupportMaterialTab,
		tests: TestsTab,
		'reaction-tests': ReactionTestsTab,
		comments: Comments,
	},

	data() {
		return {
			tab: 'basic-data',
			id_live_class: '',
			is_public: false,
			live_class_room: '',
			live_class_title: '',
			live_class_guest_limit: 0,
			live_class_description: '',
			platform_type: 'jitsi',
			embed: null,
			date_class: '',
			timezone: '',
			status: 1,
			selected_client_params: [],
			allowed_guest_areas: [],
			allowed_guest_profiles: [],
			permissions: {
				live_classes_manage: false,
			},
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			user_client_module_items: 'common/user_client_module_items',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		showTab() {
			return this.id_live_class !== 0 ? true : false
		},

		guestType() {
			return this.id_live_class !== 0 && !this.is_public ? true : false
		},

		title_live_class() {
			if (this.id_user_client_selected) {
				const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
				return obj && obj.title_live_classes
					? obj.title_live_classes == ''
						? 'live_classes'
						: obj.title_live_classes
					: 'live_classes'
			}
		},

		useReviews() {
			const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			return obj ? obj.use_comments_live_class : true
		},
	},

	methods: {
		changeTab() {
			this.tab = 'basic-data'
		},

		updateClassData({
			id,
			title,
			description,
			is_public,
			room,
			guest_limit,
			allowed_guest_areas,
			allowed_guest_profiles,
			platform_type,
			embed,
			date_class,
			timezone,
			status,
		}) {
			;(this.allowed_guest_areas = allowed_guest_areas),
				(this.allowed_guest_profiles = allowed_guest_profiles),
				(this.id_live_class = id)
			this.live_class_title = title
			this.live_class_description = description
			this.is_public = is_public
			this.live_class_room = room
			this.live_class_guest_limit = guest_limit
			this.platform_type = platform_type
			this.embed = embed
			this.date_class = date_class
			this.timezone = timezone
			this.status = status
		},

		checkPermissions() {
			const client = this.user_client_module_items.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) {
				for (const [key, value] of Object.entries(this.permissions)) {
					let obj = client.module_items.find((obj) => obj.slug === key)
					if (obj) {
						this.permissions[key] = obj.permission
					}
				}
			} else return
		},
	},

	beforeRouteUpdate(to, from, next) {
		this.id_live_class = to.params.id
		next()
	},

	created() {
		this.id_live_class = this.$route.params.id
		this.selected_client_params = this.clients.find(
			(obj) => obj.id === this.id_user_client_selected
		)
		this.checkPermissions()
	},
}
</script>

<style></style>
